import React from "react";
import {CityList} from "../CityList/CityList";
import {connect} from "react-redux";
import {openDialogAction} from "../../../comun/DialogManager/DialogManagerAction";
import {getCities} from "../CityAction";
import {CityFilters} from "../../City/CityFilter/CityFilter";



export let ManageCityFilter = ({user, cities, ...props}) => {
    
    return (
        <CityList title="Gestionar Ciudades"  action={getCities} />
    )
}


const mapDispatchToProps = dispatch => {
    return {
        onDialogOpen: data => {
            dispatch(openDialogAction(data));
        },
    }
}


const mapStateToProps = (state) => {
    return {cities: state.cities};
}
ManageCityFilter = connect(mapStateToProps, mapDispatchToProps)(ManageCityFilter);


